import { render, staticRenderFns } from "./MerchantForm.vue?vue&type=template&id=389d67ee&scoped=true"
import script from "./MerchantForm.vue?vue&type=script&lang=js"
export * from "./MerchantForm.vue?vue&type=script&lang=js"
import style0 from "./MerchantForm.vue?vue&type=style&index=0&id=389d67ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389d67ee",
  null
  
)

export default component.exports